<template>
  <div class="actor_list">
    <section class="no_padding text_center">
      <h2 class="header_underline"><span>鑑定師一覧</span>{{ title }}でお悩み</h2>

      <div v-if="actors != null">
        <div v-for="(entry, index) in actors" :key="index" class="actor_box">
          <div class="actor_profile">
            <div class="actor_profile_wrap">
              <div class="actor_image">
                <img :src="actorIconURL(entry.token)" v-if="entry.token != null && entry.token.length > 0" :alt="`${entry.name}`" />
                <img src="/assets/img/actor/noimage.png" v-else alt="画像無し" />
              </div>
              <div class="actor_name text_left">
                {{ entry.name }}先生
                <span class="actor_evaluation">
                  <img src="/assets/img/actor/evaluation.png" alt="評価数" />
                  <span>{{ entry.evaluation }}件</span>
                </span>
              </div>
            </div>
            <div class="actor_description text_left">
              <p>{{ entry.description }}</p>
            </div>
            <p><router-link :to="{ name: 'ActorDetail', params: { id: entry.id } }" class="btn arrow">詳細を見る</router-link></p>
          </div>
          <div class="actor_message_btn">
            <p><a href="#" class="btn arrow" @click.prevent="goActorMessage(entry.id)">鑑定依頼をする</a></p>
          </div>
        </div>
        <p v-if="actors.length == 0">
          鑑定師が見つかりませんでした。
        </p>
      </div>
    </section>
    <section class="text_center">
      <ul v-if="actors != null" class="pagination pl-0">
        <li
          v-if="isPrev"
          class="prev link_main--text text-decoration-underline"
        ><span @click="goPagination('prev')">前へ</span></li>
        <li
          v-if="isNext"
          class="next link_main--text text-decoration-underline"
        ><span @click="goPagination('next')">次へ</span></li>
      </ul>
      <p>
        <router-link :to="{ name: 'MailList' }" class="arrow link_main--text">メールBOX一覧に戻る</router-link>
      </p>
    </section>
  </div>
</template>

<script>
import Vue from 'vue'
import store from '@/store'
import { IMAGE_URL } from '@/common/config'
import {
  GENRE_WORRY,
  GENRE_GENRE
} from '@/helper/constant'
import { GET_GENRE_ACTORS } from '@/store/genre/actions'
import { GET_ACTOR_BY_SEND_MESSAGE } from '@/store/actor/actions'
import { FETCH_ACTORS_LIST } from '@/store/genre/mutations'

export default {
  name: 'GenreActorList',
  data () {
    return {
      worryList: GENRE_WORRY,
      genreList: GENRE_GENRE,
      type: this.$route.params.type,
      id: this.$route.params.id,
      page: this.$route.query.page || 0,
      currentPage: (this.$store.getters.actorsList != null) ? this.$store.getters.actorsList.current_page : 0,
      total: (this.$store.getters.actorsList != null) ? this.$store.getters.actorsList.total : 0,
      perPage: (this.$store.getters.actorsList != null) ? this.$store.getters.actorsList.per_page : 0,
      actors: (this.$store.getters.actorsList != null) ? this.$store.getters.actorsList.actors : null
    }
  },
  computed: {
    title () {
      if (this.type === 'worry') {
        return this.worryList.find(g => g.value === Number(this.id)).label
      } else {
        return this.genreList.find(g => g.value === Number(this.id)).label
      }
    },
    isPrev () {
      return (this.currentPage > 1)
    },
    isNext () {
      return (this.currentPage < this.pageCount)
    },
    pageCount () {
      return Math.ceil(this.total / this.perPage)
    }
  },
  methods: {
    getActors () {
      this.$store.dispatch(GET_GENRE_ACTORS, {
        type: this.type,
        id: this.id,
        params: {
          params: {
            page: this.page
          }
        }
      })
        .then((data) => {
          this.currentPage = data.current_page
          this.total = data.total
          this.perPage = data.per_page
          this.actors = data.actors
        })
        .catch(() => {
          this.$router.go(-1)
        })
    },
    goActorMessage (actorId) {
      this.$store.dispatch(GET_ACTOR_BY_SEND_MESSAGE, {
        id: actorId
      })
        .then((data) => {
          if (data.is_point_shortage) {
            this.$router.pushIsses({ name: 'UserPointShortage' })
          } else {
            this.$router.pushIsses({ name: 'ActorMessage', params: { id: actorId } })
          }
        })
        .catch(() => {})
    },
    goPagination (type) {
      const nextPage = (type === 'prev') ? this.currentPage - 1 : this.currentPage + 1
      const params = Vue.util.extend({}, this.$route.params)
      const query = Vue.util.extend({}, this.$route.query)
      query.page = String(nextPage)
      this.page = nextPage
      this.$router.pushIsses({ name: 'GenreActorList', params: params, query: query })
    },
    actorIconURL (token) {
      return IMAGE_URL + token
    }
  },
  created () {
    this.getActors()
  },
  watch: {
    page: function () {
      this.currentPage = this.total = this.perPage = 0
      this.actors = null

      this.getActors()
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!(from.name === 'ActorDetail' || from.name === 'ActorMessage' || from.name === 'UserPointShortage')) {
      store.commit(FETCH_ACTORS_LIST, null)
    }
    next()
  }
}
</script>
